module.exports = __webpack_public_path__ + "img/7_109.946a7978.png";